module.exports = __webpack_public_path__ + "img/hudson_valley_lighting_mobile.2df2ba8.png";